import { ArrowRight, Crosshair, MessageSquare, TrendingUp } from 'lucide-react';
import { Link } from '@/components/ui/link';
import { apiBaseUrl } from '@/shared/api/apiBaseUrl';
import { appPath } from '@/shared/lib/appPath';

const brandLogoSrc = appPath('/favicon.png');

const processSteps = [
  { label: 'КОНТЕКСТ', icon: MessageSquare, accent: false },
  { label: 'ДЕЙСТВИЕ', icon: Crosshair, accent: false },
  { label: 'РЕЗУЛЬТАТ', icon: TrendingUp, accent: true },
] as const;

const workflowSteps = [
  { n: 1, title: 'ДО', description: 'контекст клиента и план встречи' },
  { n: 2, title: 'ВО ВРЕМЯ', description: 'контроль методологии и подсказки как продавать' },
  { n: 3, title: 'ПОСЛЕ', description: 'резюме, оценка, следующий шаг и анализ предложений' },
] as const;

export default function LoginPage() {
  const loginHref = `${apiBaseUrl()}/auth/login?prompt=login`;

  return (
    <div className="relative min-h-dvh w-full overflow-hidden bg-neutral-background-100 text-neutral-text-900">
      <div aria-hidden className="login-dots pointer-events-none absolute inset-0" />

      <header className="absolute top-0 right-0 left-0 z-10 mx-auto flex w-full max-w-6xl items-center gap-3 px-6 py-8 sm:px-10 lg:px-14 lg:py-10">
        <img src={brandLogoSrc} alt="" width={40} height={40} className="size-10" />
        <span className="text-h3 font-medium">Sales Copilot</span>
      </header>

      <div className="relative mx-auto grid min-h-dvh w-full max-w-6xl items-center gap-12 px-6 py-8 sm:px-10 lg:grid-cols-[1fr_25rem] lg:gap-16 lg:px-14 lg:py-10">
        <section className="flex flex-col items-start gap-6">
          <div className="flex items-center gap-2 rounded-full bg-neutral-background-200 px-4 py-2 shadow-s">
            <span className="size-2 shrink-0 rounded-full bg-state-positive" />
            <span className="text-caption font-medium">ИИ ДЛЯ СЛОЖНЫХ ПРОДАЖ</span>
          </div>

          <div className="flex flex-col gap-3">
            <h1 className="text-display-m font-medium sm:text-display-l">
              Sales Copilot
            </h1>
            <p className="max-w-sm text-h2 text-neutral-text-500">
              Система управления продажами в реальном времени
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            {processSteps.map((step, i) => {
              const Icon = step.icon;
              const tone = step.accent ? 'text-state-positive' : 'text-neutral-text-900';
              return (
                <div key={step.label} className="flex items-center gap-3">
                  {i > 0 ? <ArrowRight className="size-4 shrink-0" aria-hidden /> : null}
                  <div className="flex items-center gap-2 rounded-m bg-neutral-background-200 px-4 py-3 shadow-s">
                    <Icon className={`size-4 shrink-0 ${tone}`} aria-hidden />
                    <span className={`text-caption font-medium ${tone}`}>
                      {step.label}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        <aside className="w-full rounded-l bg-neutral-background-200 p-8 shadow-l">
          <p className="text-caption font-medium text-neutral-text-500">
            КОНТУР РАБОТЫ
          </p>
          <div className="mt-3 h-px w-full bg-neutral-text-900/20" />

          <ol className="relative my-8 flex flex-col gap-6">
            <div
              aria-hidden
              className="absolute top-4 bottom-4 left-4 border-l border-dashed border-neutral-border-300"
            />
            {workflowSteps.map((step) => (
              <li key={step.n} className="relative flex gap-4">
                <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-neutral-background-100 text-body2 font-medium">
                  {step.n}
                </span>
                <div className="flex min-w-0 flex-col gap-1">
                  <span className="text-body1 font-medium">{step.title}</span>
                  <span className="text-body2 text-neutral-text-500">{step.description}</span>
                </div>
              </li>
            ))}
          </ol>

          <Link
            href={loginHref}
            target="_self"
            className="relative flex h-14 w-full items-center justify-center rounded-m bg-neutral-text-900 text-body1 font-medium text-neutral-white no-underline transition-colors dark:text-neutral-black hover:bg-neutral-black hover:text-neutral-white dark:hover:text-neutral-white hover:opacity-100"
          >
            Войти
            <ArrowRight className="absolute right-5 size-4" aria-hidden />
          </Link>
        </aside>
      </div>
    </div>
  );
}
